var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTwitterFill = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M9.979383976146982,7.265631024911544 l5.907276611440368,-6.478782379115355 h-1.2998060870569423 L9.401312321640075,6.473523143613691 l-4.138856224576053,-5.683374048312095 h-4.754553844760921 l6.235648675538964,8.597670961587113 l-6.225387048535883,6.825329577183166 h1.3032266293913026 l5.500232073651484,-6.033221695885313 l4.37487364564692,6.033221695885313 h4.795600352773246 L9.979383976146982,7.265631024911544 zM2.3857799938669486,1.780283946923911 h2.199408720993721 L14.562910704189886,15.269221075525268 l-2.199408720993721,-0.013201798021630887 L2.3857799938669486,1.780283946923911 z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTwitterFill);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/twitter-fill.d568e2bc213865634c358ae39bf2e5c7.svg";